import { useAuth } from "../hooks/useAuth";

export function Home() {
    const { checkLogin } = useAuth();
    
    checkLogin();

    return <></>;
}
